import React from 'react';

import CaregiverBasicInfo from './CaregiverBasicInfo';
import CaregivingInfo from './CaregivingInfo';
import { useOrganizationMemberDetailsContext } from './context/OrganizationMemberDetailsContext';
import MemberDetailsWrapper from './MemberDetailsWrapper';
import Demographics from './Demographics';

const OrganizationMemberDetails: React.FC = () => {
    const { memberDetails } = useOrganizationMemberDetailsContext();

    return memberDetails.owned_device_info?.member_role === 'CAREGIVER_READ_ONLY' ? (
        <>
            <CaregiverBasicInfo />
            <CaregivingInfo />
        </>
    ) : (
        <Demographics member={memberDetails} />
    );
};

const OrganizationMemberDetailsWrapped = () => (
    <MemberDetailsWrapper>
        <OrganizationMemberDetails />
    </MemberDetailsWrapper>
);

export default OrganizationMemberDetailsWrapped;
